var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerbutton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99943 1.3335V8.00016M12.2394 4.42683C13.0783 5.26602 13.6496 6.33512 13.881 7.49896C14.1123 8.66279 13.9934 9.86909 13.5392 10.9653C13.085 12.0616 12.316 12.9985 11.3293 13.6577C10.3427 14.3169 9.1827 14.6688 7.9961 14.6688C6.80949 14.6688 5.64953 14.3169 4.66288 13.6577C3.67623 12.9985 2.90719 12.0616 2.45301 10.9653C1.99882 9.86909 1.87989 8.66279 2.11124 7.49896C2.34259 6.33512 2.91384 5.26602 3.75276 4.42683",
    stroke: "#F04438",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbutton);
export default __webpack_public_path__ + "static/media/powerbutton.2afe0370f94d50b2aa55b6ed9cada2aa.svg";
export { ForwardRef as ReactComponent };